<template>
	<v-card v-if="factors.length"
		elevation="0">
		<v-card-title class="text-h6">{{ title }}</v-card-title>
		<v-card-subtitle class="text-subtitle-2">{{ subtitle }}</v-card-subtitle>

		<v-card-text>
			<v-simple-table dense>
				<template v-slot:default>
					<thead>
						<tr>
							<th width="50%" class="text-left">Показник</th>
							<th width="10%" class="text-left">Умовне позначення</th>
							<th width="10%" class="text-left">Значення</th>
							<th width="30%" class="text-left">Опис</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item, index) in factors" :key="item.id" >
							<td>{{ item.name }}</td>
							<td>{{ item.code }}</td>
							<td>{{ item.val }}</td>
							<td>{{ item.description }}</td>
						</tr>
					</tbody>
				</template>
			</v-simple-table>
		</v-card-text>
	</v-card>
</template>

<script>
export default {
	data: () => ({
		title: 'Розрахунок вартості',
		subtitle: 'На основі аналізу довідкових даних щодо даного транспортного засобу встановлені такі показники:',
	}),

	props: {
		item: { type: Object, default: () => {}},
	},

	computed: {
		factors() {
			return this.item.hasOwnProperty('factors') ? this.item.factors: [];
		},
	},

	methods: {
		
	},
}
</script>